import header from './header';
import childChart from './childChart';
import parentChart from './parentChart';
import footer from './footer';

export default [header, childChart, parentChart, footer];
